import { makeAutoObservable } from 'mobx';
import { PortfolioIntegrationDto } from '../../../../defs/api';

export class PortfolioIntegrationMobxDto implements PortfolioIntegrationDto {
    hasTrading212Token: boolean = false;

    hasTrading212SecretKey: boolean = false;

    trading212Error: string | null = null;

    constructor() {
        makeAutoObservable(this);
    }

    static create(dto: PortfolioIntegrationDto): PortfolioIntegrationMobxDto {
        const mobxDto = new PortfolioIntegrationMobxDto();
        return Object.assign(mobxDto, dto);
    }

    static createFromArray(dtos: PortfolioIntegrationDto[]): PortfolioIntegrationMobxDto[] {
        return dtos.map((dto) => PortfolioIntegrationMobxDto.create(dto));
    }
}
